import AvailiableMeals from "./AvailiableMeals"
import MealsSummary from "./MealsSummary"

const Meals=()=>{
  return  <>
  <MealsSummary/>
  <AvailiableMeals/>
  </>
}
export default Meals